<template>
    <ds-list-item
        class="file-upload-list-item"
        data-qa="file-upload-list-item"
        border-style="none"
        clickable
        :title="fileName"
        :description="formattedDate"
        @click="handleSelect"
    >
        <template #leading>
            <DsRadio
                :val="fileId.toString()"
                :value="selectedFileId.toString()"
                style="padding: var(--ds-spacing-050) var(--ds-spacing-025);"
            >
                <template #default>
                    <span />
                </template>
            </DsRadio>
        </template>

        <template v-if="isHovered || isSelected" #trailing>
            <div class="list-items-container" @click.stop.prevent>
                <list-item-button
                    :tooltip-label="$t('unlayerBuilder.fileUpload.tooltip.preview')"
                    icon="eye-show"
                    data-qa="file-upload-list-item-button-preview"
                    @click="handlePreview"
                />

                <list-item-button
                    :tooltip-label="$t('unlayerBuilder.fileUpload.tooltip.download')"
                    icon="download"
                    data-qa="file-upload-list-item-button-download"
                    @click="handleDownload"
                />

                <list-item-button
                    :tooltip-label="$t('unlayerBuilder.fileUpload.tooltip.delete')"
                    icon="trash-2"
                    destructive
                    data-qa="file-upload-list-item-button-delete"
                    @click="isConfirmingDelete = true"
                />

                <ds-confirm-dialog
                    :is-open="isConfirmingDelete"
                    :title="$t('unlayerBuilder.fileUpload.deleteConfirmDialog.title')"
                    :message="$t('unlayerBuilder.fileUpload.deleteConfirmDialog.message')"
                    :confirm-label="$t('unlayerBuilder.fileUpload.deleteConfirmDialog.confirmButtonLabel')"
                    cancel-label="Cancel"
                    class="file-upload-delete-confirm-modal"
                    destructive
                    data-qa="file-upload-delete-confirm-modal"
                    @cancel="handleClose"
                    @confirm="handleDeleteConfirm"
                />
            </div>
        </template>
    </ds-list-item>
</template>

<script>
import moment from 'moment';

import { DISPLAY_DATE_FORMAT_WITH_YEAR } from '@/components/broadcast/constants/dateFormats.constants';
import ListItemButton from '@/components/shared/ListItemButton.vue';

export default {
    name: 'FileUploadListItem',

    components: {
        ListItemButton,
    },

    props: {
        fileName: String,
        fileUrl: String,
        fileLastUpdated: String,
        fileId: Number,
        isSelected: Boolean,
        selectedFileId: {
            type: [String, Number],
            default: '',
        },
    },

    data() {
        return {
            isHovered: false,
            isConfirmingDelete: false,
        };
    },

    mounted() {
        this.$el.addEventListener('mouseenter', this.handleEnter);
        this.$el.addEventListener('mouseleave', this.handleLeave);
    },

    destroyed() {
        this.$el.removeEventListener('mouseenter', this.handleEnter);
        this.$el.removeEventListener('mouseleave', this.handleLeave);
    },

    computed: {
        formattedDate() {
            return moment(this.fileLastUpdated)
                .format(DISPLAY_DATE_FORMAT_WITH_YEAR);
        },
    },

    methods: {
        handleEnter() {
            this.isHovered = true;
        },

        handleLeave() {
            this.isHovered = false;
        },

        handleSelect() {
            this.$emit('select', { name: this.fileName, id: this.fileId, url: this.fileUrl });
        },

        handlePreview() {
            window.open(this.fileUrl, '_blank');
        },

        handleDownload() {
            const fileLink = document.createElement('a');

            fileLink.href = this.fileUrl;
            fileLink.setAttribute('download', '');

            fileLink.click();

            fileLink.remove();
        },

        handleDeleteConfirm() {
            this.$emit('delete');
            this.isConfirmingDelete = false;
        },

        handleClose() {
            this.isConfirmingDelete = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.file-upload-list-item {
    height: px-to-rem(70);
}

.list-items-container {
    position: relative;
    top: -15px;
}
</style>

<!--this is required as the styling for the file upload modal is overriding the default padding for the delete confirm modal-->
<style lang="scss">
.file-upload-delete-confirm-modal .modal-content-wrapper {
    padding: $spacing-200;
}
</style>
